import { showError } from '../../components/Messages';
import { BaseController } from '../BaseController';

export default class TipoDeEmpresaController extends BaseController {
    constructor(props) {
        super(props);
        this.name = 'TipoDeEmpresaController';
    }

    getTitulosDaTabela = () => {
        return [
            { titulo: this.lang.telaDeCadastroDeTipoDeEmpresa.codigo, orderby: 'Id', className: 'codigo' },            
            { titulo: this.lang.telaDeCadastroDeTipoDeEmpresa.descricao, width: '100%', orderby: null },
        ];
    };

    getDadosDaTabela = (item) => {
        return [item.id, item.descricao];
    };

    getObjetoDeDados = () => {
        return new Promise((resolve, reject) => {
            let state = this.view.state;
            let item = state.itemSelecionado;

            if (!item.descricao) {
                showError(this.lang.telaDeCadastroDeTipoDeEmpresa.mensagens.informeaDescricaoDoTipoDeEmpresa);
                reject();
                return;
            }

            if (item.descricao.length > 100) {
                showError(this.lang.telaDeCadastroDeTipoDeEmpresa.mensagens.descricaodoTipoDeEmpresaMaximo100Caracteres);
                reject();
                return;
            }

            var input = {                
                descricao: item.descricao,                
            };

            if (state.alterando) {
                input.id = parseInt(item.id);
            }
            resolve(input);
        });
    };
}
